module.exports = __webpack_public_path__ + "img/Interface.c5c91106.png";